import { ABUtils } from '../../utils';

export const composeResidentParams = (search) => {
    const { isResident, shouldShowResident } = search;
    const { isResidentDiscount } = ABUtils.getABs();
    const hasResidentParams = isResident || (isResidentDiscount && shouldShowResident);

    return hasResidentParams ? ';resident=true' : '';
};
